const inputStyles = {
    appBar: {
        bottom: "0",
        top: "auto",
    },
    layout: {
        marginLeft: "auto",
        marginRight: "auto"
    },
    menuButton: {
        marginLeft: "auto"
    },
    appTitle: {
        color: '#fff',
    },
    title: {
        fontSize: '20px',
        marginBottom: '32px',
        fontWeight: '500px',
        lineHeight: '32px'
    },
    titleLabel: {
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: '450',
        fontSize: '24px',
        lineHeight: '32px',
        color: '#2A2A3E',
        padding: '0px 0px 16px 4px',
        borderBottom: '1px solid #DCDEDF'
    },
    stepLabel: {
        fontSize: '16px',
        marginTop: '16px'
    },
    paper: {
        boxShadow: '0px 1px 4px rgb(0 0 0 / 25%)',
        borderRadius: '8px',
        marginBottom: '24px'
    },
    buttons: {
        display: "flex",
        justifyContent: "flex-end",
    },
    button: {
        marginTop: '28px',
        // marginLeft: theme.spacing(1),
    },
    buttonWrapper: {
        display: 'flex',
        justifyContent: 'center'
    },
    margin24: {
        marginRight: '24px',
        textTransform: 'none'
    },
    formControl: {
        width: '100%'
    },
    mainContent: {
        padding: '32px',
        maxWidth: '768px',
        margin: '0px auto'
    },
    paperLabel: {
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: '600',
        fontSize: '16px',
        lineHeight: '24px',
        color: '#212121',
        padding: '16px 0px 8px 32px',
        borderBottom: '1px solid #DCDEDF'
    },
    paperContent: {
        padding: '32px'
    },
    actionBtn: {
        marginRight: '24px',
        textTransform: 'none',
        width: '250px'
    },
    label: {
        fontWeight: '300'
    },
    contentHeader: {
        marginBottom: '24px'
    },
    fullWidth: {
        width: '100%'
    },
    saveButton: {
        marginRight: '20px',
        textTransform: 'none',
        width: '150px',
      
    },
    submitButton:{
        marginRight: '20px',
        textTransform: 'none',
        width: '150px',
        color:'white',
        backgroundColor:'#5f56a6'
    },
    staffActionBtn: {
        textTransform: 'unset',
        width: '158px',
        height: '44px'
    },
    rm64 : {
      paddingRight: '110px'
  }
}

export default inputStyles
